module.exports = __webpack_public_path__ + "img/11.a131a302.jpg";